(() => {
  if (window.MayLondonHomeVideos) return;
  window.MayLondonHomeVideos = true;
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const players = new Map();
  const cancelFrame = (video, state) => {
    if (state.frame == null) return;
    if (video.cancelVideoFrameCallback) video.cancelVideoFrameCallback(state.frame);
    else cancelAnimationFrame(state.frame);
    state.frame = null;
  };
  const allowed = state => state.visible && !state.failed && !document.hidden && !motion.matches && !navigator.connection?.saveData;
  const update = (video, state) => {
    if (!allowed(state)) {
      video.pause();
      cancelFrame(video, state);
      if (motion.matches) delete video.dataset.videoReady;
      return;
    }
    if (!video.getAttribute('src')) video.src = video.dataset.src;
    video.muted = true;
    const speed = Number(video.dataset.videoSpeed);
    video.defaultPlaybackRate = video.playbackRate = speed >= .5 && speed <= 1 ? speed : .8;
    if (video.paused) video.play().then(() => { if (!allowed(state)) video.pause(); }).catch(() => { delete video.dataset.videoReady; });
  };
  const observer = 'IntersectionObserver' in window ? new IntersectionObserver(entries => entries.forEach(entry => {
    const state = players.get(entry.target);
    if (state) { state.visible = entry.isIntersecting; update(entry.target, state); }
  }), { threshold: 0 }) : null;
  const init = (scope = document) => scope.querySelectorAll('[data-home-video], [data-scene-video]').forEach(video => {
    if (players.has(video)) return;
    const state = { visible: !observer, failed: false, frame: null };
    players.set(video, state);
    video.addEventListener('playing', () => {
      cancelFrame(video, state);
      if (!allowed(state)) { video.pause(); return; }
      const reveal = () => {
        state.frame = null;
        if (allowed(state) && video.readyState >= 2) video.dataset.videoReady = 'true';
      };
      state.frame = video.requestVideoFrameCallback ? video.requestVideoFrameCallback(reveal) : requestAnimationFrame(reveal);
    });
    video.addEventListener('error', () => { state.failed = true; cancelFrame(video, state); delete video.dataset.videoReady; video.pause(); });
    if (observer) observer.observe(video); else update(video, state);
  });
  const updateAll = () => players.forEach((state, video) => update(video, state));
  document.addEventListener('visibilitychange', updateAll);
  motion.addEventListener('change', updateAll);
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => players.forEach((state, video) => {
    if (event.target.contains(video)) { video.pause(); cancelFrame(video, state); observer?.unobserve(video); players.delete(video); }
  }));
  init();
})();
